<nav class="navbar bg-body-tertiary">
  <div class="container d-flex justify-content-between">
    <a class="navbar-brand d-flex align-items-center" routerLink="/">
      <img
        src="/logo.png"
        alt="Daily Dev Resource"
        height="40"
        class="logo rounded-2"
      />
    </a>
    
    @if (auth.user(); as user) {
    <div class="d-flex justify-content-between gap-2">
      <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
      <a class="nav-link" routerLink="/resources" routerLinkActive="active">Resources</a>
    </div>
    <div>
        <span>
          Hi, {{ user.email }}
        </span>
  
        <button
          class="btn btn-outline-danger btn-sm"
          (click)="logout()"
        >
          Logout
        </button>
      </div>
      } @else {
        <a
          class="btn btn-primary btn-sm"
          routerLink="/login"
        >
          Login
        </a>
      }
  </div>
</nav>